import { View, Button } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { Divider } from "@/components/shared/divider";

export type OurBankDetailProps = {
  merchantName: string;
  accountNumber: string;
  invoiceId: string;
  onCopyAccountNumber: () => void;
  onCopyReference: () => void;
};

export const OurBankDetail = ({
  merchantName,
  accountNumber,
  invoiceId,
  onCopyAccountNumber,
  onCopyReference,
}: OurBankDetailProps) => (
  <View className="flex flex-col gap-2 rounded-lg bg-white px-6 py-4">
    <Typography variant="label-md" className="mb-2">
      Our Bank Details
    </Typography>
    <View className="flex flex-col gap-2">
      <Typography variant="body-sm" color="foreground-intermediate">
        Account Name (DBS)
      </Typography>
      <Typography variant="label-sm">{merchantName}</Typography>
    </View>
    <Divider className="my-2" />
    <View className="flex flex-row items-center justify-between gap-2">
      <View className="flex flex-col gap-2">
        <Typography variant="body-sm" color="foreground-intermediate">
          Account Number
        </Typography>
        <Typography variant="label-sm">{accountNumber}</Typography>
      </View>
      <Button
        variant="tertiary"
        size="md"
        iconName="copy"
        iconSize="lg"
        color="CTA2"
        iconColor="CTA2"
        iconAlignment="start"
        onClick={onCopyAccountNumber}
      >
        Copy
      </Button>
    </View>
    <Divider className="my-2" />
    <View className="flex flex-row items-center justify-between gap-2">
      <View className="flex flex-col gap-2">
        <Typography variant="body-sm" color="foreground-intermediate">
          Reference
        </Typography>
        <Typography variant="label-sm">{`P${invoiceId}`}</Typography>
      </View>
      <Button
        variant="tertiary"
        size="md"
        iconName="copy"
        iconSize="lg"
        color="CTA2"
        iconColor="CTA2"
        iconAlignment="start"
        onClick={onCopyReference}
      >
        Copy
      </Button>
    </View>
  </View>
);
